import { R } from '@core/utils/r';
import { Endpoint } from '@business/api/endpoint';
import {
  HelpArticleResponse,
  ArticleCategoryId,
  HACategoryBreadcrumbResponse,
  HACategoryStructureResponse,
  HelpArticleId,
  KBHelpArticleResponse,
  SearchHelpArticleResponse,
} from '@business/entities/helpArticle';
import { HATAG } from '@business/constants/helparticle';

export function fetchHelpArticles(id: string, options: { search?: string } = {}, fromDashboard = false) {
  const params = R.objectCompact({ search: options.search });
  return Endpoint.get<HelpArticleResponse[]>(`@gc/kb/help-articles/${id}`, { params });
}

export function searchHelpArticle(search: string, tags: HATAG[]) {
  return Endpoint.get<SearchHelpArticleResponse[]>(`@gc/kb/search-articles`, { params: { search, tags } });
}

export function fetchHelpArticleCategories(categoryId: string, options: { search?: string } = {}) {
  const params = R.objectCompact({ search: options.search });
  return Endpoint.get<HACategoryStructureResponse[]>(`@gc/kb/categories/${categoryId}`, { params });
}

export function fetchCategoryBreadcrumbs(id: ArticleCategoryId, articleId: HelpArticleId = '0') {
  return Endpoint.get<HACategoryBreadcrumbResponse[]>(`@gc/kb/category-breadcrumbs/${id}`, { params: { articleId } });
}

export function fetchHelpArticle(helpArticleId: HelpArticleId) {
  return Endpoint.get<KBHelpArticleResponse>(`@gc/kb/help-article/${helpArticleId}`);
}

export function sendArticleFeedback(id: string, email: string) {
  return Endpoint.post<KBHelpArticleResponse>(`@gc/kb/article-feedback/${id}`, { data: { email } });
}
